module.exports = __webpack_public_path__ + "static/media/feature-2-map.9a660190.svg";